import { gql } from '@apollo/client';

export const USER_REGISTER = gql`
  mutation UserRegister($registerPayload: RegisterUserInput!) {
    userRegister(registerPayload: $registerPayload) {
      cynergy_id
      email
      phone
    }
  }
`;

export const ORG_REGISTER = gql`
  mutation OrgRegister($registerPayload: RegisterUserInput!) {
    userRegister(registerPayload: $registerPayload) {
      cynergy_id
      email
      phone
    }
  }
`;
